import React from "react";
import {
  ChevronLeftIcon,
  MagnifyingGlassIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";

function Help({ setView, setActiveIcon, setupDetails }) {
  return (
    <div
      className="-m-2.5 overflow-auto"
      style={{
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        // maxHeight: "359px",
      }}
    >
      <div
        style={{
          background: `linear-gradient(90deg, ${
            setupDetails?.widgetCustomizations?.primaryColor || "#4c73de"
          } 0%,  ${
            setupDetails?.widgetCustomizations?.secondaryColor || "#2a4dad"
          } 100%)`,
        }}
        className="bg-blue-800 p-4 "
      >
        <div className="flex items-center">
          <ChevronLeftIcon
            onClick={() => {
              setView("LandingWindow");
              setActiveIcon("home");
            }}
            className="w-5 h-5 text-white cursor-pointer"
          />
          <div className="flex-grow text-center text-white text-xl font-semibold">
            Help
          </div>
        </div>

        <div className="relative mt-4">
          <input
            type="text"
            placeholder="Search for help"
            className="text-sm rounded-lg px-4 py-3.5 w-full"
          />
          <div className="absolute inset-y-0 right-4 flex items-center">
            <MagnifyingGlassIcon
              style={{
                color:
                  setupDetails?.widgetCustomizations?.primaryColor || "#4c73de",
              }}
              className="w-5 h-5 cursor-pointer"
              strokeWidth={2}
            />
          </div>
        </div>
      </div>

      <div className="font-semibold p-5 text-start border-b">
        15 collections
      </div>
      {/* ArticleSection */}

      <div
        className="px-5 cursor-pointer hover:bg-gray-200"
        onClick={() => setView("DexKorOverview")}
      >
        <div className="flex items-center py-3 border-b">
          <div className="text-start flex-1">
            <h5 className="font-bold">DexKor Overview</h5>
            <p className="text-sm pt-1 pb-1 break-words">
              See how your AI-first customer service solution works.
            </p>
            <span className="text-sm text-gray-600">20 articles</span>
          </div>
          <ChevronRightIcon className="h-3 w-3 ml-2" strokeWidth={4} />
        </div>
      </div>

      <div className="px-5 cursor-pointer hover:bg-gray-200">
        <div className="flex items-center py-3 border-b">
          <div className="text-start flex-1">
            <h5 className="font-bold">Getting Started</h5>
            <p className="text-sm pt-1 pb-1 break-words">
              Everything you need to know to get started with DexKor.
            </p>
            <span className="text-sm text-gray-600">36 articles</span>
          </div>
          <ChevronRightIcon className="h-3 w-3 ml-2" strokeWidth={4} />
        </div>
      </div>

      <div className="px-5 cursor-pointer hover:bg-gray-200">
        <div className="flex items-center py-3 border-b">
          <div className="text-start flex-1">
            <h5 className="font-bold">Inbox</h5>
            <p className="text-sm pt-1 pb-1 break-words">
              Boosting productivity with a workspace that connects your inbox,
              tickets, and help center.
            </p>
            <span className="text-sm text-gray-600">93 articles</span>
          </div>
          <ChevronRightIcon className="h-3 w-3 ml-2" strokeWidth={4} />
        </div>
      </div>

      <div className="px-5 cursor-pointer hover:bg-gray-200">
        <div className="flex items-center py-3 border-b">
          <div className="text-start flex-1">
            <h5 className="font-bold">Channels</h5>
            <span className="text-sm text-gray-600">52 articles</span>
          </div>
          <ChevronRightIcon className="h-3 w-3 ml-2" strokeWidth={4} />
        </div>
      </div>
    </div>
  );
}

export default Help;
